// @flow

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {appActions} from './store'

import Modal from './views/modals'
import Header from './views/header'
import TabbedContent from './views/tabbed-content'
import InfoPanel from '@/elements/info-panel'

import styled from 'styled-components'
import {selectThemeColours} from './theme-colours'
import {getSessionPartnerId, selectPartnerFavIcon} from '@/partnerID'

type Props = {
  fetchInitialData: () => void,
  infoMessage: ?string,
  userCountryCode: string,
}

const TopBar = styled.div`
  border-top: 22px solid;
  border-top-color: ${(props) => props.themeColours.primaryColour};
`

export class RawApp extends Component<Props> {
  componentDidMount () {
    this.props.fetchInitialData()
    const favicon = document.createElement('link')
    favicon.rel = 'icon'
    favicon.href = selectPartnerFavIcon()
    // eslint-disable-next-line flowtype-errors/show-errors
    document.head.appendChild(favicon)
  }

  render () {
    const themeColour = selectThemeColours(getSessionPartnerId())
    return (
      <TopBar themeColours={themeColour}>
        <Modal />
        <div className="container" id={`country-${this.props.userCountryCode}`}>
          {this.props.showAppLoader ? <div id='loader'></div> : ''}
          <Header />
          <TabbedContent />
        </div>
        <InfoPanel />
      </TopBar>
    )
  }
}

const mapStateToProps = (state) => ({
  userCountryCode: state.app.user.countryCode,
  startDate: state.ui.graphStartDate,
  endDate: state.ui.graphEndDate,
  showAppLoader: state.app.showAppLoader,
})

export default connect(
  mapStateToProps,
  appActions,
)(RawApp)



// WEBPACK FOOTER //
// ./src/app.js